import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import Preloader from "./components/Preloader/Preloader";
import Header from "./components/Header/Header";
import StickyCta from "./components/StickyCta/StickyCta";
import MobileMenu from "./components/MobileMenu/MobileMenu";
import Hero from "./components/Hero/Hero";
import Trending from "./components/Trending/Trending";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import FeaturedProperties from "./components/FeaturedProperties/FeaturedProperties";
import Testimonials from "./components/Testimonials/Testimonials";
import Footer from "./components/Footer/Footer";
import BackToTop from "./components/BackToTop/BackToTop";
import VintageBackground from "./components/VintageBackground/VintageBackground";
import SignIn from "./Pages/SignIn";
import SignUp from "./Pages/SignUp";

function App() {
  return (
    <Router>
      <VintageBackground />
      <Preloader />
      <Header />
      <StickyCta />
      <MobileMenu />
      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Trending />
                <HowItWorks />
                <FeaturedProperties />
                <Testimonials />
                <Footer />
              </>
            }
          />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
        </Routes>
      </main>
      <BackToTop />
    </Router>
  );
}

export default App;
